<div class="" style="max-width: 500px">
  <div class="d-flex justify-content-between mb-3">
    <div class="d-flex gap-2 align-items-center">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.75 11.25V20.25C12.75 20.4489 12.671 20.6397 12.5303 20.7803C12.3897 20.921 12.1989 21 12 21C11.8011 21 11.6103 20.921 11.4697 20.7803C11.329 20.6397 11.25 20.4489 11.25 20.25V11.25C11.25 11.0511 11.329 10.8603 11.4697 10.7197C11.6103 10.579 11.8011 10.5 12 10.5C12.1989 10.5 12.3897 10.579 12.5303 10.7197C12.671 10.8603 12.75 11.0511 12.75 11.25ZM18.75 18C18.5511 18 18.3603 18.079 18.2197 18.2197C18.079 18.3603 18 18.5511 18 18.75V20.25C18 20.4489 18.079 20.6397 18.2197 20.7803C18.3603 20.921 18.5511 21 18.75 21C18.9489 21 19.1397 20.921 19.2803 20.7803C19.421 20.6397 19.5 20.4489 19.5 20.25V18.75C19.5 18.5511 19.421 18.3603 19.2803 18.2197C19.1397 18.079 18.9489 18 18.75 18ZM21 15H19.5V3.75C19.5 3.55109 19.421 3.36032 19.2803 3.21967C19.1397 3.07902 18.9489 3 18.75 3C18.5511 3 18.3603 3.07902 18.2197 3.21967C18.079 3.36032 18 3.55109 18 3.75V15H16.5C16.3011 15 16.1103 15.079 15.9697 15.2197C15.829 15.3603 15.75 15.5511 15.75 15.75C15.75 15.9489 15.829 16.1397 15.9697 16.2803C16.1103 16.421 16.3011 16.5 16.5 16.5H21C21.1989 16.5 21.3897 16.421 21.5303 16.2803C21.671 16.1397 21.75 15.9489 21.75 15.75C21.75 15.5511 21.671 15.3603 21.5303 15.2197C21.3897 15.079 21.1989 15 21 15ZM5.25 15C5.05109 15 4.86032 15.079 4.71967 15.2197C4.57902 15.3603 4.5 15.5511 4.5 15.75V20.25C4.5 20.4489 4.57902 20.6397 4.71967 20.7803C4.86032 20.921 5.05109 21 5.25 21C5.44891 21 5.63968 20.921 5.78033 20.7803C5.92098 20.6397 6 20.4489 6 20.25V15.75C6 15.5511 5.92098 15.3603 5.78033 15.2197C5.63968 15.079 5.44891 15 5.25 15ZM7.5 12H6V3.75C6 3.55109 5.92098 3.36032 5.78033 3.21967C5.63968 3.07902 5.44891 3 5.25 3C5.05109 3 4.86032 3.07902 4.71967 3.21967C4.57902 3.36032 4.5 3.55109 4.5 3.75V12H3C2.80109 12 2.61032 12.079 2.46967 12.2197C2.32902 12.3603 2.25 12.5511 2.25 12.75C2.25 12.9489 2.32902 13.1397 2.46967 13.2803C2.61032 13.421 2.80109 13.5 3 13.5H7.5C7.69891 13.5 7.88968 13.421 8.03033 13.2803C8.17098 13.1397 8.25 12.9489 8.25 12.75C8.25 12.5511 8.17098 12.3603 8.03033 12.2197C7.88968 12.079 7.69891 12 7.5 12ZM14.25 7.5H12.75V3.75C12.75 3.55109 12.671 3.36032 12.5303 3.21967C12.3897 3.07902 12.1989 3 12 3C11.8011 3 11.6103 3.07902 11.4697 3.21967C11.329 3.36032 11.25 3.55109 11.25 3.75V7.5H9.75C9.55109 7.5 9.36032 7.57902 9.21967 7.71967C9.07902 7.86032 9 8.05109 9 8.25C9 8.44891 9.07902 8.63968 9.21967 8.78033C9.36032 8.92098 9.55109 9 9.75 9H14.25C14.4489 9 14.6397 8.92098 14.7803 8.78033C14.921 8.63968 15 8.44891 15 8.25C15 8.05109 14.921 7.86032 14.7803 7.71967C14.6397 7.57902 14.4489 7.5 14.25 7.5Z"
          fill="#3199D0"
        />
      </svg>
      <h2 class="m-0 p-0" mat-dialog-title>Precificação Padrão</h2>
    </div>
    <svg
      mat-dialog-close
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      class="bi bi-x-lg"
      viewBox="0 0 16 16"
    >
      <path
        d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"
      />
    </svg>
  </div>
  <mat-dialog-content class="mat-typography">
    <p class="">
      Utilize essa opção para seguir o Padrão do Sistema, mantendo o
      Parcelamento em 12x, Desconto à vista de 10% e Cálculo por Renda Bruta
      Anual (RBA).
    </p>
    <p class="">
      A precificação Padrão consiste em 3% sobre a RBA, com um valor mínimo por
      Projeto Consultoria de R$3.000 e sem um valor Máximo.
    </p>
  </mat-dialog-content>

  <div class="d-grid justify-content-end w-100 mt-2">
    <button
      class="btn btn-primary order-2 order-md-0 order-lg-0"
      mat-dialog-close
    >
      Entendi
    </button>
  </div>
</div>
